// assets
import { Archive, Category, Insights, Map, School } from "@mui/icons-material";
import { RoleLevel } from "../../../../../../../domain/entities/Role";

// ==============================|| ENROLLMENT & CAPACITY MENU ITEMS ||============================== //

const enrollment = {
  id: "enrollment",
  title: "Enrollment & Capacity",
  caption: "School enrollment data",
  type: "group",
  level: RoleLevel.SignatureRequestor,
  hidden: (siteConfigs) => siteConfigs?.enableEnrollmentCapacity !== "On",
  children: [
    {
      id: "schoolSeats",
      title: "By School",
      type: "item",
      icon: School,
      color: "#2E7D32",
      url: "/schoolSeats",
      breadcrumbs: false,
    },
    {
      id: "programSeats",
      title: "By Program",
      type: "item",
      icon: Category,
      color: "#00838F",
      url: "/programSeats",
      breadcrumbs: false,
    },
    {
      id: "zoneSeats",
      title: "By Zone",
      type: "item",
      icon: Map,
      color: "#E65100",
      url: "/zoneSeats",
      breadcrumbs: false,
    },
    {
      id: "programDemand",
      title: "Program Demand",
      type: "item",
      icon: Insights,
      color: "#1565C0",
      url: "/programDemand",
      breadcrumbs: false,
      hidden: (siteConfigs) => siteConfigs?.enableProgramDemand !== "On",
    },
    {
      id: "archiveDocuments",
      title: "Document Archive",
      type: "item",
      icon: Archive,
      color: "#5D4037",
      url: "/archiveDocuments",
      breadcrumbs: false,
      hidden: (siteConfigs) => siteConfigs?.enableDocumentArchive !== "On",
    },
  ],
};

export default enrollment;
